import { useEffect, useState } from "react";

import { useFormikContext } from "formik";
import { shallowEqual } from "react-redux";

import { usePrompt } from "@sso/hooks/usePrompt";

interface CheckDirtyFormProps<T> {
  initialValues?: T;
  isDataLoading?: boolean;
}

export const CheckDirtyForm = <T,>({ initialValues, isDataLoading }: CheckDirtyFormProps<T>) => {
  const [isDirty, setIsDirty] = useState(false);
  const { values } = useFormikContext<T>();

  usePrompt("Are you sure you want to leave? Your Data is not submitted!", isDirty);
  usePrompt("Your Request is in processing, please wait to be done.", isDataLoading);

  useEffect(() => {
    if (!initialValues) {
      return;
    }
    setIsDirty(!shallowEqual(initialValues, values));
  }, [initialValues, values]);
  return null;
};
